const outputDoc = {
  title: 'Testament',
  from: 'von',
  born: ' geboren am ',
  civilStatus: {
    single: 'Ledig',
    married: 'Verheiratet',
    widowed: 'Verwitwet',
    divorced: 'Geschieden',
    registered_partnership: 'Eingetragene Partnerschaft',
  },
  civil_status: 'Familienstand: {{civil_status}}',
  address: 'Adresse: {{address}}',
  declare: 'Ich, {{first_name}} {{last_name}}, erkläre Folgendes:  ',

  paragraph1: 'Ich widerrufe alle Testamente, die ich zuvor verfasst habe.',

  paragraph2:
    'Die laufenden Verbindlichkeiten und Todesfallkosten sind aus dem Nachlass zu bezahlen.',

  paragraph3: '{{civil_status}}',

  receivesNothing: 'erhält nichts.',

  and: 'und',

  p4MarriedSpouse: {
    marriedStatus: {
      male: 'Meine Ehefrau',
      female: 'Mein Ehemann',
    },
    livingPartnershipStatus: {
      male: 'Meine Partnerin',
      female: 'Mein Partner',
    },
    partnerStatus: {
      male: 'Meine Partnerin',
      female: 'Mein Partner',
    },
    born: ', geboren am {{birthday}}, ',
    receivesAsHeir: 'erhält als Erbin die gesamte verfügbare Quote.',
  },

  marriedSpouseChildren: {
    biologicalChildren: {
      oneChild: {
        main: 'Mein leibliches und rechtlich anerkanntes Kind ',
        born: ', geboren am {{birthday}}, ',
        receive: 'erhält seinen Pflichtteil meines Nachlasses.',
      },
      multipleChildren: {
        main: 'Meine leiblichen und rechtlich anerkannten Kinder ',
        born: ', geboren am {{birthday}}, ',
        receive: 'erhalten jeweils ihren Pflichtteil meines Nachlasses.',
      },
    },
  },

  marriedSpouseUsufruct: {
    marriedStatus: {
      male: 'Meiner Ehefrau',
      female: 'Meinem Ehemann',
    },
    livingPartnershipStatus: {
      male: 'Meiner Partnerin',
      female: 'Meinem Partner',
    },
    usufructRights:
      '{{partnerTerminology}} {{partnerFullNameAndBirthday}}, ordne ich gemäss Art. 473 ZGB die lebenslängliche Nutzniessung an den Erbteilen meiner Kinder an. Die Nutzniessung erstreckt sich auf den gesamten Nachlass.',
  },

  p4UnmarriedPartner: {
    receives: 'erhält die gesamte frei verfügbare Quote.',
    receivesProperty: 'erhält insbesondere auch',
    theProperty: 'die Liegenschaft',
    atTheAddress: 'an der Adresse',
    assignedToProperty: 'zu Eigentum zugewiesen.',
    born: ', geboren am {{birthday}}, ',
    genderStatus: {
      male: 'Meine Lebenspartnerin',
      female: 'Mein Lebenspartner',
      male1: 'meiner Lebenspartnerin',
      female1: 'meinem Lebenspartner',
      registeredPartnerMale: 'Meine Partnerin',
      registeredPartnerFemale: 'Mein Partner',
    },
  },

  p5UnmarriedPartnerWithChildren: {
    commonPartnership: {
      oneChild: {
        main: 'Unser gemeinsams Kind, ',
        born: ', geboren am {{birthday}}, ',
        receive: 'bzw. dessen Nachkommen erhalten den Pflichtteil.',
      },
      multipleChildren: {
        main: 'Unsere gemeinsamen Kinder, ',
        born: ', geboren am {{birthday}}, ',
        receive: 'bzw. all deren Nachkommen erhalten je den Pflichtteil.',
      },
      and: 'und',
    },
    otherPartnership: {
      oneChild: {
        main: 'Mein nicht-gemeinsames Kind, ',
        born: ', geboren am {{birthday}}, ',
        receive: 'bzw. dessen Nachkommen erhalten den Pflichtteil.',
      },
      multipleChildren: {
        main: 'Meine nicht-gemeinsamen Kinder, ',
        born: ', geboren am {{birthday}}, ',
        receive:
          'bzw. all deren Nachkommen erhalten je zu gleichen Teilen den Pflichtteil.',
      },
    },
    noPartnership: {
      oneChild: {
        main: 'Mein Kind, ',
        born: ', geboren am {{birthday}}, ',
        receive: ' bzw. dessen Nachkommen erhalten den Pflichtteil.',
      },
      multipleChildren: {
        main: 'Meine Kinder, ',
        born: ', geboren am {{birthday}}, ',
        receive: ' bzw. all deren Nachkommen erhalten je den Pflichtteil.',
      },
    },
    deathCase:
      'Sollte ich mit {{partner}} gleichzeitig versterben, so {{childrenCase}}',
    born: ', geboren am {{birthday}}, ',
    childrenCase: {
      oneChild: {
        fromCommonMarriage: 'erhält unser gemeinsames Kind, ',
        fromOtherMarriage: 'erhält unser nicht-gemeinsames Kind, ',
        fromUnknownMarriage: 'erhält mein Kind,',
      },
      onesDescendants: 'bzw. dessen Nachkommen sämtliche Vermögenswerte.',
      multipleChildren: {
        fromCommonMarriage: 'erhalten unsere gemeinsamen Kinder, ',
        fromOtherMarriage: 'erhalten unsere nicht-gemeinsamen Kinder, ',
        fromUnknownMarriage: 'erhalten meine Kinder, ',
      },
      allDescendants: 'bzw. all deren Nachkommen je sämtliche Vermögenswerte.',
    },
  },

  p4Child: {
    biologicalChildren: {
      oneChild: {
        main: 'Ich setze mein Kind ',
        born: ', geboren am {{birthday}}, ',
        receive:
          'als Erbin meines gesamten Nachlasses ein. Es erhält meinen gesamten Nachlass.',
      },
      multipleChildren: {
        main: 'Ich setze meine Kinder ',
        born: ', geboren am {{birthday}}, ',
        receive:
          'zu gleichen Teilen als Erbinnen meines gesamten Nachlasses ein.',
      },
    },
    partnerCase: {
      male: 'Meine Ehefrau',
      female: 'Mein Ehemann',
      born: ', geboren am {{birthday}}, ',
      receivesNothing: 'erhält keine Zuteilung aus meinem Nachlass.',
      receivesCompulsoryPortion:
        'erhält aus meinem Nachlass ihren Pflichtteil.',
    },
  },

  unmarriedChildrenChoice: {
    biologicalChildren: {
      oneChild: {
        main: 'Ich setze mein Kind ',
        born: ', geboren am {{birthday}}, ',
        receive:
          'als Erbin meines gesamten Nachlasses ein. Es erhält meinen gesamten Nachlass.',
      },
      multipleChildren: {
        main: 'Ich setze meine Kinder ',
        born: ', geboren am {{birthday}}, ',
        receive:
          'zu gleichen Teilen als Erbinnen meines gesamten Nachlasses ein.',
      },
    },
  },

  unmarriedPartnerCase: {
    male: 'Meine Lebenspartnerin',
    female: 'Mein Lebenspartner',
    born: ', geboren am {{birthday}}, ',
    receivesNothing: 'soll aus meinem Nachlass keine Zuwendung erhalten.',
  },

  unmarriedPartnerDeathCase: {
    male: 'Sollte ich gleichzeitig mit meiner Lebenspartnerin versterben oder sie den Erbfall nicht erleben, so erhält',
    female:
      'Sollte ich gleichzeitig mit meinem Lebenspartner versterben oder er den Erbfall nicht erleben, so erhält',
    multipleChildren: 'mein Kind, ',
    oneChild: 'mein Kind, ',
    born: ', geboren am {{birthday}}, ',
    descendants: 'bzw. dessen Nachkommen',
    multipleDescendants: 'bzw. deren Nachkommen',
    inheritAll:
      'den gesamten Nachlass zu gleichen Teilen mit weiteren Erben (falls vorhanden) oder allein, wenn keine weiteren gesetzlichen Erben vorhanden sind.',
    and: 'sowie',
  },

  unmarriedInstitutionChoice: {
    biologicalChildren: {
      oneChild: {
        main: 'Mein leibliches und rechtlich anerkanntes Kind, ',
        born: ', geboren am {{birthday}}, ',
        receive: 'erhält seinen Pflichtteil meines Nachlasses.',
      },
      multipleChildren: {
        main: 'Meine leiblichen und rechtlich anerkannten Kinder, ',
        born: ', geboren am {{birthday}}, ',
        receive: 'erhalten jeweils ihren Pflichtteil meines Nachlasses.',
      },
    },
  },

  p4Institution: {
    oneInstitution: {
      main: 'Die Institution',
      receives: 'erhält',
    },
    multipleInstitutions: {
      main: 'Die Institutionen',
      receives: 'erhalten',
    },
    finals:
      ' je zu gleichen Teilen alle Vermögenswerte im Rahmen der frei verfügbaren Quote. ',
    final: ' alle Vermögenswerte im Rahmen der frei verfügbaren Quote. ',
    partnerReceives: 'erhält aus meinem Nachlass ihren Pflichtteil.',
    born: ', geboren am {{birthday}}, ',
    and: ' und ',
  },

  p5MarriedSpouse: {
    marriedStatus: {
      male: 'Meine Ehegattin',
      female: 'Mein Ehegatte',
    },
    livingPartnershipStatus: {
      male: 'Meine Partnerin',
      female: 'Mein Partner',
    },
    particularReceives: {
      marriedStatus:
        'Meine Ehegattin soll im Rahmen der verfügbaren Quote die Liegenschaft an der {{address}}, als Alleineigentum, erhalten. Reicht die verfügbare Quote dafür nicht aus, so soll die Zuteilung unter Anrechnung auf ihren Erbanteil erfolgen.',
      livingPartnershipStatus:
        'Meine Partnerin soll im Rahmen der verfügbaren Quote die Liegenschaft an der {{address}}, als Alleineigentum, erhalten. Reicht die verfügbare Quote dafür nicht aus, so soll die Zuteilung unter Anrechnung auf ihren Erbanteil erfolgen.',
    },
    theProperty: '',
    atTheAddress: '',
    assignedToProperty: '',
  },

  spouseSimultaneousDeathClause:
    'Sollte {{partnerTerminology}} {{partnerFullNameAndBirthday}} gleichzeitig mit mir versterben oder den Erbfall nicht erleben, so fällt die verfügbare Quote meines Nachlasses an meine beiden Kinder {{childrenNames}} zu gleichen Teilen.',

  p5Institution: {
    commonMarriage: {
      oneChild: {
        main: 'Unser gemeinsames Kind, ',
        born: ' geboren am {{birthday}}, ',
        receive: 'bzw. dessen Nachkommen erhalten den Pflichtteil.',
      },
      multipleChildren: {
        main: 'Unsere gemeinsamen Kinder, ',
        born: ' geboren am {{birthday}}, ',
        receive: 'bzw. all deren Nachkommen erhalten je den Pflichtteil.',
      },
      and: 'und',
    },
    otherMarriage: {
      oneChild: {
        main: 'Mein nicht-gemeinsames Kind, ',
        born: ' geboren am {{birthday}}, ',
        receive: 'bzw. dessen Nachkommen erhalten den Pflichtteil.',
      },
      multipleChildren: {
        main: 'Meine nicht-gemeinsamen Kinder, ',
        born: ' geboren am {{birthday}}, ',
        receive: 'bzw. all deren Nachkommen erhalten je den Pflichtteil.',
      },
      and: 'und',
    },
  },

  p6MarriedSpouse: {
    oneChild: {
      commonMarriage: 'Unser gemeinsames Kind, ',
      otherMarriage: 'Mein nicht-gemeinsames Kind, ',
      born: ', geboren am {{birthday}}, ',
      receives: 'bzw. dessen Nachkommen erhalten ',
    },
    multipleChildren: {
      commonMarriage: 'Unsere gemeinsamen Kinder, ',
      otherMarriage: 'Meine nicht-gemeinsamen Kinder, ',
      born: ', geboren am {{birthday}}, ',
      receives: 'bzw. all deren Nachkommen erhalten je',
    },
    final:
      'den Pflichtteil, belastet indes mit der gemäss Art. 473 ZGB eingeräumten lebenslänglichen Nutzniessung. ',
  },

  willExecutor:
    'Als Willensvollstrecker für meinen gesamten Nachlass setze ich {{executor1}} ein. Als Ersatz-Willensvollstrecker setze ich {{executor2}} ein.',

  forFollowing: {
    main: 'Für folgende Vermögenswerte gilt jedoch eine abweichende Regelung:',
    asset: '{{asset}}, {{address}} geht an: {{benefiter}}. ',
    devisionProvision:
      'Dies ist eine Teilungsvorschrift zugunsten {{benefiter}}, keine zusätzlich Begünstigung.',
  },
  optionalUsufruct: {
    marriedMale: 'Meiner Ehefrau',
    marriedFemale: 'Meinem Ehemann',
    partnerMale: 'Meiner Partnerin',
    partnerFemale: 'Meinem Partner',
    receives:
      ', ordne ich gemäss Art. 473 ZGB die lebenslängliche Nutzniessung an den Erbteilen meiner Kinder an. Die Nutzniessung erstreckt sich auf den gesamten Nachlass.',
    propertyPart: ' an meiner Liegenschaft in {{address}}',
    andOr: ' und/oder',
    estatePart:
      ' an Teilen meines Nachlasses, soweit dies mit den Rechten der gesetzlichen oder eingesetzten Erben vereinbar ist.',
  },
};

export default outputDoc;
